<div class="container-fluid my-5">
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col-xl-4 order-xl-2 mb-5 mb-xl-0" *ngIf="!loading">
        <div class="card card-profile shadow">
          <div class="card-body">
            <div class="row">
              <div class="col-md-12" *ngIf="relations_image">
                <div class="form-group">
                  <label class="form-control-label">{{ relations_image.label }}</label>
                  <input hidden (change)="uploadFile($event)" accept="image/jpeg, image/png, image/webp" type="file"
                    #inputFile>
                  <div style="height: 200px;width: 100%;" class="mx-auto p-0  overflow-auto">
                    <div style="height: 200px;width: 100%;" class="mx-auto p-0 border position-relative">
                      <img class="profil" [src]="image" alt="user image"
                        style="height: 100%;width: 100%;object-fit: cover;">
                      <button type="button" style="left: 0;
                              bottom: 0;
                              font-size: small;
                              background: #00000038;" (click)='inputFile.click()'
                        class="w-100 btn text-white position-absolute">
                        Uploader
                        <i style="font-size: small;" class="fas fa-pen"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12 my-3" *ngIf="html_section != ''">
                <div [innerHTML]="html_section"></div>
              </div>
              <div class="col-md-12">
                <button type="button" *ngFor="let el of actions[endpoint]" class="btn btn-xl btn-{{el.type}} w-100 mb-2"
                  (click)="clickBtnAction(el)" title="{{ el.title }}">
                  <i [ngClass]="el.icon"></i> {{el.title}}
                </button>
              </div>
              <div class="col-md-12" *ngIf="relations_button">
                <button class="btn btn-studiomap w-100" *ngIf="relations_button.array.length > 0"
                  [routerLink]="['/'+ relations_button.endpoint+'/edit/'+relations_button.array[0].id]">{{
                  relations_button.label }}</button>
                <button class="btn btn-success w-100" *ngIf="relations_button.array.length == 0"
                  [routerLink]="['/'+ relations_button.endpoint+'/ajouter']"
                  [queryParams]="get_query_params(relations_button.belongTo)">Ajouter {{ relations_button.label
                  }}</button>
              </div>

              <div class="col-md-12 mb-4" *ngFor="let myElement of relations_select">
                <div *ngIf="myElement.component == 'select'">
                  <label class="form-control-label">{{ myElement.label }} :</label>
                  <select class="form-control form-control-alternative"
                    (change)="selected_option($event,myElement.name)" formControlName="{{ myElement.name }}">
                    <option value="">selectionner</option>
                    <option [value]="element['id']" *ngFor="let element of myElement.array">
                      {{ get_option(element,myElement.index) }}
                    </option>
                  </select>
                </div>

                <div
                  *ngIf="myElement.component == 'autocomplete' && myElement.has_value != undefined && !myElement.has_value">
                  <label class="form-control-label">{{ myElement.label }} :</label>
                  <div class="ng-autocomplete w-100">
                    <ng-autocomplete [data]="myElement.array" [searchKeyword]="myElement.index"
                      placeholder="{{ myElement.placeHolder }}" [itemTemplate]="itemTemplate"
                      (selected)="selectEvent($event,myElement)" (inputCleared)="onCleared(myElement)"
                      [notFoundTemplate]="notFoundTemplate" (input)="onInputChange($event, myElement)">
                    </ng-autocomplete>
                    <ng-template #itemTemplate let-item>
                      <a [innerHTML]="item[myElement.index]"></a>
                    </ng-template>
                    <ng-template #notFoundTemplate let-notFound>
                      <div [innerHTML]="notFound"></div>
                    </ng-template>
                  </div>
                </div>
              </div>
              <div class="col-md-12 mb-4" *ngFor="let item of relations_list">
                <label class="form-control-label" *ngIf="item.component != 'map'">{{ item.label }} :</label>
                <ul class="list-group" *ngIf="item.component == 'list'">
                  <li class="list-group-item d-flex justify-content-between align-items-center"
                    *ngFor="let element of item.array">
                    <a [routerLink]="['/'+item.endpoint+'/edit/'+element[item.value_index]]"><span
                        class="text-warning mr-2">
                        <i class="fas fa-edit"></i></span>{{ displayTextItemRelationList(element,item) }}</a>
                    <button (click)="clickBtnDeleteItemList(element,item)" class="btn btn-sm btn-icon-only text-danger"
                      type="button">
                      <i class="fa fa-times"></i>
                    </button>
                  </li>
                  <li class="list-group-item bg-success"><span class="text-white mr-2"><i
                        class="fas fa-plus"></i></span><a [routerLink]="['/'+item.endpoint+'/ajouter']"
                      [queryParams]="get_query_params(item.belongTo)" class="text-white">Ajouter</a></li>

                </ul>
                <div *ngIf="item.component == 'map' && data_result['lat'] != undefined && data_result['lng'] != undefined && data_result['lat'] != '' && data_result['lng'] != '' && data_result['lat'] != null && data_result['lng'] != null" >
                  <label class="form-control-label">{{ item.label }} :</label>
                  <app-short-map [latitude]="data_result['lat']" [longitude]="data_result['lng']"></app-short-map>
                </div>
              </div>
              <div class="col-md-12 mb-4" *ngFor="let element of relations_multi_check">
                <h3>{{ element.label }}</h3>
                <p style="color: #8d8d8d;" *ngIf="element.init_array.length == 0">Liste est vide...</p>
                <div class="form-check" *ngFor="let itemMultiCheck of element.init_array">
                  <input class="form-check-input" type="checkbox" value=""
                    (change)="onChangeCheckBox(element,itemMultiCheck)"
                    [checked]="check_multi_box_selected(itemMultiCheck[element.index])">
                  <label class="form-check-label">
                    {{ itemMultiCheck[element.index] }}
                  </label>
                </div>
                <button *ngIf="element.show_button_add" class="btn btn-success w-100 mt-2"
                  [routerLink]="['/'+ element.endpoint+'/ajouter']">{{
                  element.button_label
                  }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-8 order-xl-1">
        <div class="card bg-secondary shadow">
          <div class="card-header bg-white border-0">
            <div class="row align-items-center">
              <div class="col-6">
                <h3 class="mb-0">Modifier <span class="text-warning">{{ endpoint }} #{{ id }}</span></h3>
              </div>
              <div class="col-6 text-right">
                <button type="button" class="btn btn-xl btn-dark" (click)="back()"><i
                    class="fa fa-angle-left"></i></button>
                <button type="submit" class="btn btn-xl btn-studiomap">Modifier</button>
              </div>
            </div>
          </div>
          <div class="card-body">

            <div class="pl-lg-4">
              <div class="row">


                <div class="col-md-12" *ngFor="let item of inputs">

                  <div class="form-group" *ngIf="item.type == 'phone'">
                    <label class="form-control-label">Phone :</label>
                    <input type="text" id="phone" class="form-control form-control-alternative"
                      placeholder="{{ item.label }}" formControlName="{{ item.name }}"
                      [ngClass]="{'border-danger':form_controls[item.name].errors != null && submitted}">
                  </div>

                  <div class="form-group" *ngIf="item.type == 'address'">
                    <label class="form-control-label">{{ item.label }} :</label>
                    <input type="text" #placesRef ngx-google-places-autocomplete
                      class="form-control form-control-alternative" placeholder="{{ item.label }}"
                      formControlName="{{ item.name }}" (onAddressChange)="handleAddressChange($event)"
                      [ngClass]="{'border-danger':form_controls[item.name].errors != null && submitted}">
                  </div>
                  <div class="form-group" *ngIf="item.type == 'address-item'">
                    <label class="form-control-label">{{ item.label }} :</label>
                    <input type="text" class="form-control form-control-alternative" placeholder="{{ item.label }}"
                      formControlName="{{ item.name }}"
                      [ngClass]="{'border-danger':form_controls[item.name].errors != null && submitted}" readonly>
                  </div>



                  <div class="form-group"
                    *ngIf="item.type == 'text' && (item.editable == null || item.editable == 'undefined' || item.editable == true)">
                    <label class="form-control-label">{{ item.label }} :</label>
                    <input type="text" class="form-control form-control-alternative" placeholder="{{ item.label }}"
                      formControlName="{{ item.name }}" *ngIf="item.readOnly"
                      [ngClass]="{'border-danger':form_controls[item.name].errors != null && submitted}" readonly>

                    <input type="text" class="form-control form-control-alternative" placeholder="{{ item.label }}"
                      formControlName="{{ item.name }}" *ngIf="!item.readOnly && !item.maxlength"
                      [ngClass]="{'border-danger': form_controls[item.name].errors != null && submitted}">

                    <input type="text" class="form-control form-control-alternative" placeholder="{{ item.label }}"
                      formControlName="{{ item.name }}" *ngIf="!item.readOnly && item.maxlength"
                      maxlength="{{ item.maxlength }}"
                      [ngClass]="{'border-danger': form_controls[item.name].errors != null && submitted}">

                  </div>
                  <div class="form-group"
                    *ngIf="item.type == 'number'  && (item.editable == null || item.editable == 'undefined' || item.editable == true)">
                    <label class="form-control-label">{{ item.label }} :</label>
                    <input type="number" class="form-control form-control-alternative" placeholder="{{ item.label }}"
                      formControlName="{{ item.name }}" *ngIf="item.readOnly" readonly
                      [ngClass]="{'border-danger': form_controls[item.name].errors != null && submitted}">
                    <input type="number" class="form-control form-control-alternative" placeholder="{{ item.label }}"
                      formControlName="{{ item.name }}" *ngIf="!item.readOnly"
                      [ngClass]="{'border-danger': form_controls[item.name].errors != null && submitted}" min="0">
                  </div>
                  <div class="form-group"
                    *ngIf="item.type == 'password'  && (item.editable == null || item.editable == 'undefined' || item.editable == true)">
                    <label class="form-control-label">{{ item.label }} :</label>
                    <input type="text" class="form-control form-control-alternative" placeholder="{{ item.label }}"
                      formControlName="{{ item.name }}"
                      [ngClass]="{'border-danger': form_controls[item.name].errors != null && submitted}">
                  </div>
                  <div class="form-group"
                    *ngIf="item.type == 'long-text'  && (item.editable == null || item.editable == 'undefined' || item.editable == true)">
                    <label class="form-control-label">{{ item.label }} :</label>
                    <textarea formControlName="{{ item.name }}" class="form-control" rows="10"
                      [ngClass]="{'border-danger': form_controls[item.name].errors != null && submitted}"></textarea>
                  </div>
                  <div class="form-group"
                    *ngIf="item.type == 'textarea'  && (item.editable == null || item.editable == 'undefined' || item.editable == true)">
                    <label class="form-control-label">{{ item.label }} :</label>
                    <ckeditor [editor]="Editor" formControlName="{{ item.name }}"></ckeditor>
                  </div>
                  <div class="form-group"
                    *ngIf="item.type == 'ai-textarea'  && (item.editable == null || item.editable == 'undefined' || item.editable == true)">
                    <label class="form-control-label">{{ item.label }} :</label>
                    <button type="button" class="btn btn-round btn-studiomap float-right"
                      (click)="generate_ai_description(item)">AI</button>
                    <button type="button" class="btn btn-round btn-dark float-right"
                      (click)="init_ai_description(item)">Rénistialiser</button>

                    <ckeditor [editor]="Editor" formControlName="{{ item.name }}"></ckeditor>
                  </div>

                  <div class="form-group"
                    *ngIf="item.type == 'enum'  && (item.editable == null || item.editable == 'undefined' || item.editable == true)">
                    <label class="form-control-label">{{ item.label }} :</label>
                    <select class="form-control" formControlName="{{ item.name }}">
                      <option value="{{ value }}" *ngFor="let value of item.list">{{ value }}</option>
                    </select>
                  </div>
                  <div class="form-group"
                    *ngIf="item.type == 'enum-object'  && (item.editable == null || item.editable == 'undefined' || item.editable == true)">
                    <label class="form-control-label">{{ item.label }} :</label>
                    <select class="form-control" formControlName="{{ item.name }}">
                      <option value="{{ item_list.key }}" *ngFor="let item_list of item.list">{{ item_list.text }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group"
                    *ngIf="item.type == 'enum-object'  && item.editable != null && item.editable != 'undefined' && item.editable != undefined && item.editable == false">
                    <label class="form-control-label">{{ item.label }} :</label>
                    <input class="form-control" type="text" formControlName="{{ item.name }}" readOnly>
                  </div>
                  <div class="form-group"
                    *ngIf="item.type == 'switch'  && (item.editable == null || item.editable == 'undefined' || item.editable == true)">
                    <label class="form-control-label">{{ item.label }} :</label>
                    <label class="switch">
                      <input type="checkbox" formControlName="{{ item.name }}">
                      <span class="slider round"></span>
                    </label>
                  </div>
                  <div class="form-group"
                    *ngIf="item.type == 'date'  && (item.editable == null || item.editable == 'undefined' || item.editable == true)">
                    <label class="form-control-label">{{ item.label }} :</label>
                    <div class="input-group"
                      [ngClass]="{'border-danger': form_controls[item.name].errors != null && submitted}">
                      <input class="form-control" placeholder="yyyy-mm-dd" formControlName="{{ item.name }}"
                        ngbDatepicker #start="ngbDatepicker" />
                      <button class="btn btn-studiomap ri fa fa-calendar" (click)="start.toggle()" type="button"></button>
                    </div>
                  </div>
                  <div class="form-group"
                    *ngIf="item.type == 'datetime'  && (item.editable == null || item.editable == 'undefined' || item.editable == true)">
                    <label class="form-control-label">{{ item.label }} :</label>
                    <div class="input-group"
                      [ngClass]="{'border-danger': form_controls[item.name].errors != null && submitted}">
                      <input [owlDateTime]="dt1" [owlDateTimeTrigger]="dt1" placeholder="yyyy-mm-dd"
                        class="form-control" formControlName="{{ item.name }}">
                      <owl-date-time #dt1></owl-date-time>
                    </div>
                  </div>

                </div>

                <div class="col-md-12" *ngFor="let item of section_gallery">
                  <label class="form-control-label">{{ item.label }} :</label>
                  <input hidden (change)="uploadGalleryFile($event,item)" accept=".jpeg,.jpg,.png,.gif,.webp,.bmp,.svg"
                    type="file" #inputFile>


                  <div class="row" [sortablejs]="item.init_images">
                    <div class="col-xl-4 col-md-6 my-3" *ngFor="let image of item.init_images;let i = index;">
                      <div class="bg-light position-relative rounded border" style="height: 185px;">
                        <img class="h-100 w-100 cover" [src]="image.thumbnail" alt="images">
                        <span class="order">{{i+1}}</span>
                        <i (click)="deleteServerImage(i,image)" class="fas fa-times delete"></i>
                      </div>
                    </div>

                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <h5>Ajouter des nouvelles photos :</h5>
                    </div>
                    <div class="col-xl-4 col-md-6 my-3" *ngFor="let image of item.images;let i = index;">
                      <div class="bg-light position-relative rounded border" style="height: 185px;">
                        <img class="h-100 w-100 cover" [src]="image" alt="images">
                        <i (click)="removeImage(i,item)" class="fas fa-times delete"></i>
                      </div>
                    </div>
                    <div [ngClass]="{'col-12':item.images.length==0,'col-xl-4 col-md-6':item.images.length>0}"
                      class=" my-3">
                      <div class="bg-white rounded border-dashed d-flex align-items-center" style="height: 185px;">
                        <button type="button" (click)='inputFile.click()'
                          class="mx-auto btn p-3 rounded-circle btn-link"
                          style="border: 2px rgba(226, 226, 226, 0.9) dashed;">
                          <img height="40" width="40" src="assets/img/camera.svg" alt="user image">
                        </button>
                      </div>
                    </div>
                  </div>




                </div>

                <div class="col-md-12" *ngFor="let item of custom_files">
                  <div class="form-group">
                    <label class="form-control-label" *ngIf="item.object.label != ''">{{ item.object.label }} :</label>
                    <input type="file" class="form-control" (change)="uploadInputsFile(item.name,$event)">
                  </div>
                  <div class="form-group" *ngIf="item.value != ''">
                    <a href="{{ item.value.url }}" class="link-dark" target="_blank">Télécharger</a>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </form>

  <app-endpoint-relation [endpoint_relation]="endpointRelation"></app-endpoint-relation>

  <div class="row" *ngIf="sections.length > 0">
    <div class="col-md-8  order-xl-2 mb-5 mb-xl-0 mt-3">
      <div class="card card-profile shadow ">
        <div class="card-body">
          <div class="row">

            <div class="col-md-12" *ngFor="let section of sections">
              <form [formGroup]="section.form"
                (ngSubmit)="section_onSubmit(section.name_function,section.onSubmit(),section.from)">
                <h3 class="mb-2">{{ section.label }} :</h3>

                <div class="form-group" *ngFor="let custom_input of section.inputs">
                  <input type="{{ custom_input.type }}" class="form-control form-control-alternative"
                    formControlName="{{ custom_input.name }}" placeholder="{{ custom_input.placeholder }}">
                </div>
                <div class="text-right">
                  <button type="submit" class="btn btn-xl btn-studiomap">Modifier</button>
                </div>
              </form>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>



</div>